import { t } from "i18next";

export const signupFormLogic = {
    formFields: ['email', 'password'],
    regexError: false,
    nullError: false,
    email: {
        id:"email",
        className: "",
        value: '',
        name: 'email',
        type: 'email',
        label: t('sign_up.email_address'),
        required: true,
        maxLength: 50,
        dangerWarn: false,
        errorMessage: null,
        regex: "^(?!\\.)(?!.*\\.\\.)(?!.*\\.@)[a-zA-Z0-9.!#$%&'*+\\-/=?^_`{|}~]+@(?!\\-)[a-zA-Z0-9.-]*[a-zA-Z0-9]\\.(?!\\-)[a-zA-Z0-9-]+[a-zA-Z0-9]$"
    },
    password: {
        id: "password",
        className: "",
        value: '',
        name: 'password',
        type: 'password',
        label: t('sign_up.password'),
        required: true,
        maxLength: 64,
        dangerWarn: false,
        errorMessage: null,
        regex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!#$%&'*+\\-/=?^_`{|}~.@])(?!.*[^!#$%&'*+\\-/=?^_`{|}~.@a-zA-Z0-9]).{8,64}$",
        showPassword: false,
        showPasswordIcon: true,
    }
}